import { render, staticRenderFns } from "./SettingCurrency.vue?vue&type=template&id=f4d71b7a&scoped=true&"
import script from "./SettingCurrency.vue?vue&type=script&lang=js&"
export * from "./SettingCurrency.vue?vue&type=script&lang=js&"
import style0 from "./SettingCurrency.vue?vue&type=style&index=0&id=f4d71b7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d71b7a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
installComponents(component, {VApp})


/* vuetify-loader */
import installDirectives from "!../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
